<template>
  <div class='institutional-qnr-results-section-view view is-flex gap-2 py-6'>
    <QnrSectionNav :sections='sections' :n='n' :clientGroupID='clientGroupID'/>

    <div class='is-flex-col main'>
      <header class='mb-6'>
        <h1 class='title is-2'>{{ section ? section.name : 'Section' }}</h1>
        <p class='subtitle is-6 has-text-grey' v-if='section'>{{ section.desc }}</p>
      </header>
      <div class='is-flex-col gap-3' v-if="section && section.slug != 'wizard'">
        <QuestionResponse
          v-for='(question, id) in section.questions'
          :key='id'
          :id="id + 1"
          :question='question'
          :assignedColors='assignedColors'/>
      </div>
      <div class='is-flex-col gap-3' v-else-if="section">
        <ValuesWizardResults :prospects="prospects" :assignedColors="assignedColors"/>
      </div>

      <footer class='is-flex justify-between mt-6'>
        <router-link :to='prev' v-if='prevSection'>
          <button class='button is-primary'>
            Previous
          </button>
        </router-link>
        <div v-else></div>

        <router-link :to='next' v-if='nextSection'>
          <button class='button is-primary'>
            Next Section
          </button>
        </router-link>

        <router-link :to="{ name: 'institutional-qnr-results-ips', query: { group: clientGroupID }}" v-else>
          <button class='button is-primary'>
            Sample IPS
          </button>
        </router-link>
      </footer>
    </div>
  </div>
</template>


<script>
import QnrSectionNav from '../../components/institutional_questionnaire/QnrSectionNav.vue';
import QuestionResponse from '../../components/institutional_questionnaire/QuestionResponse.vue';
import ValuesWizardResults from '../../components/institutional_questionnaire/ValuesWizardResults.vue';


export default {
  name: 'institutional-qnr-results-section-view',
  components: { QnrSectionNav, QuestionResponse, ValuesWizardResults },
  props: ['sections', 'assignedColors', 'prospects', 'clientGroupID'],
  data() {
    return { /* Local variables */ };
  },
  beforeCreate() {},
  created() {
  },
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    n() {
      return parseInt(this.$route.params.section);
    },
    prevSection() {
      return this.sections[this.n - 2];
    },
    section() {
      return this.sections[this.n - 1];
    },
    sectionComponent() {
      const components = this.section.components;
      return components ? components.results : null;
    },
    nextSection() {
      return this.sections[this.n];
    },
    prev() {
      return this.url(this.n - 1);
    },
    next() {
      return this.url(this.n + 1);
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  methods: {
    url(section) {
      return {
        name: 'institutional-qnr-results-section',
        params: { section },
        query: { group: this.clientGroupID },
      };
    },
  },
};
</script>


<style scoped>
.main > * {
  max-width: 60rem;
  min-width: 50rem;
}
</style>
